<template>
  <div class="statement-cta">
    <p v-if="errors && errors.agreed" class="error">{{ errors.agreed }}</p>
    <p>
      <DrButton
        :loading="loading"
        data-cy="btn-statement-agree"
        :class="{ 'btn-outline': data.agreed === false }"
        class="w-full btn-blue"
        @click.prevent="handleAgree"
      >
        I agree
      </DrButton>
    </p>
    <p>
      <DrButton
        class="btn-red btn-outline w-full"
        data-cy="btn-statement-disagree"
        :class="{ 'is-active': data.agreed === false }"
        @click.prevent="handleDisagree"
      >
        I disagree
      </DrButton>
    </p>
    <div v-if="data.agreed === false && requireMoreInfo">
      <div v-if="requireMoreInfoMessage">{{ requireMoreInfoMessage }}</div>
      <div v-else>
        <p class="help text-grey-550 mb-2">Please provide more information</p>
        <DrTextarea
          v-model="data.comment"
          :error="errors.comment"
          placeholder="Enter details here..."
          data-cy="statement-disagree-comment"
          @input="validation"
        />
      </div>
      <div class="flex">
        <DrButton
          :loading="loading"
          data-cy="btn-disagree-confirm"
          class="btn-blue w-full mt-4"
          @click.prevent="submitDisagree"
        >
          Next
        </DrButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: String,
      default: '',
    },
    requireMoreInfo: {
      type: Boolean,
      required: true,
    },
    requireMoreInfoMessage: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      data: {
        agreed: null,
        comment: null,
      },
      errors: {
        agreed: null,
        comment: null,
      },
    }
  },
  created () {
    if (this.comment) {
      this.data.agreed = false
      this.data.comment = this.comment
    }
  },
  methods: {
    handleAgree () {
      this.data.comment = ''
      this.data.agreed = true
      if (this.validation()) {
        this.$emit('submitted', this.data)
      }
    },
    handleDisagree () {
      this.data.agreed = false
      if (!this.requireMoreInfo) this.submitDisagree()
    },
    validation () {
      // Agree required
      if (this.data.agreed === null) {
        this.errors.agreed = 'You must agree or disagree.'
        return false
      } else {
        this.errors.agreed = null
      }
      // If Agree === false then comment required
      if (this.data.agreed === false && !this.data.comment && this.requireMoreInfo && !this.requireMoreInfoMessage) {
        this.errors.comment = 'You must provide more information.'
        return false
      } else {
        this.errors.comment = null
      }

      return true
    },
    submitDisagree () {
      if (this.validation()) {
        this.$emit('submitted', this.data)
        this.data = {
          agreed: null,
          comment: null,
        }
      }
    },
  },
}
</script>
